import GaLogger from './GaLogger';

class SibLogger extends GaLogger {
  getContentRenderedPayload(dabuResponse) {
    const {
      kramResponse = {},
      adResultsDisplayedTop,
      adResultsDisplayedBottom,
      adResultsDisplayed,
    } = dabuResponse;

    const { pageParams, adContext } = this.adInstance;

    return {
      event: 'ad-content-rendered',
      adDimensions: `${dabuResponse.templateWidth}x${dabuResponse.templateHeight}`,
      abTestIds: adContext.abTestIds,
      bingTypeTagPrimary: pageParams.rtb || dabuResponse.typeTag,
      bingTypeTagAbTests: adContext.abTestBingTypeTag,
      eventDate: new Date().toISOString(),
      eventType: dabuResponse.eventType,
      isGenericResponse: dabuResponse.isGenericResponse,
      oCode: pageParams.o || dabuResponse.o,
      templateName: dabuResponse.templateName,
      templateNumOfLinks: dabuResponse.templateNumOfLinks,
      generator: kramResponse.generator,
      urlDomain: kramResponse.url_domain,
      urlSlug: kramResponse.url_slug,
      ad_resultsDisplayedTop: adResultsDisplayedTop,
      ad_resultsDisplayedBottom: adResultsDisplayedBottom,
      ad_resultsDisplayed: adResultsDisplayed,
      googleClientId: adContext.googleClientId,
      googlePrimaryChannel: pageParams.rch,
    };
  }
}

export default SibLogger;
